import { GridColDef } from '@mui/x-data-grid';

export const portfolioStakedDetailColumns: GridColDef[] = [
  {
    minWidth: 100,
    field: 'no',
    headerName: 'No',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'totStakeAmt',
    headerName: 'Stake Amount',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'usdt',
    headerName: 'Usdt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'startDt',
    headerName: 'reward start',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 200,
    field: 'endDt',
    headerName: 'reward end',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 100,
    field: 'cnt',
    headerName: 'Cumulative Number of Rewards',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const portfolioRewardDoneColumns: GridColDef[] = [
  {
    minWidth: 100,
    field: 'no',
    headerName: 'No',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'totStakeAmt',
    headerName: 'Stake Amount',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'rewardAmt',
    headerName: 'Reward',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const portfolioUnStakedDetailColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'no',
    headerName: 'No.',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  // {
  //   minWidth: 150,
  //   field: 'stakeAmt',
  //   headerName: 'Stake Amount',
  //   headerAlign: 'center',
  //   align: 'center',
  //   sortable: false,
  // },

  {
    minWidth: 150,
    field: 'totStakeAmt',
    headerName: 'tot Stake Amt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'regDt',
    headerName: 'Stake Time',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const portfolioClaimRewardDoneColumns: GridColDef[] = [
  {
    minWidth: 100,
    field: 'no',
    headerName: 'No',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'totStakeAmt',
    headerName: 'Stake Amount',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'rewardAmt',
    headerName: 'reward',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const portfolioPlanRewardDoneColumns: GridColDef[] = [
  {
    minWidth: 100,
    field: 'no',
    headerName: 'No',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'startDt',
    headerName: 'start dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'endDt',
    headerName: 'end dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const portfolioWidthrawColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'usdt',
    headerName: 'Cumulative Principal(USDT)',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'ticker',
    headerName: 'Average market price(SFL/USDT)',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'totStakeAmt',
    headerName: ' SFL Principal',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'regDt',
    headerName: 'Date',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];
